var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{attrs:{"title":"Действия пользователей","icon":""}}),_c('user-actions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }